import { Card, CardContent, Divider, Toolbar } from "@material-ui/core";
import React from "react";

export const VerticalTabViewContainer = ({ children }: any) => {
  return <div>{children}</div>;
};

export const VerticalTabTitleContainer = ({ children }: any) => {
  return (
    <>
      <Toolbar variant={"dense"} style={{ height: 48 }}>
        {children}
      </Toolbar>
      <Divider />
    </>
  );
};

export const NoTitleContainer = ({ children }: any) => {
  return <></>;
};

export const SmallViewContainer = ({
  children,
  maxContentWidth = 600
}: any) => {
  return <Card style={{ maxWidth: maxContentWidth }}>{children}</Card>;
};

export const VerticalTabContentContainer = ({
  children,
  maxContentWidth = 800
}: any) => {
  return (
    <CardContent style={{ maxWidth: maxContentWidth }}>{children}</CardContent>
  );
};

export const TabViewContainer = ({ children }: any) => {
  return <Card>{children}</Card>;
};

export const TabTitleContainer = ({ children }: any) => {
  return (
    <>
      <Toolbar>{children}</Toolbar>
      <Divider />
    </>
  );
};

export const TabContentContainer = ({ children }: any) => {
  return <>{children}</>;
};
